import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { useAuthorization } from './useAuthorization';

const ProtectedRoute = ({
  children,
  action = null,
  redirectTo = '/',
  ...rest
}) => {
  const auth = useAuthorization();
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={props => {
        if (action && !auth.can(action)) {
          return (
            <Redirect
              to={{
                pathname: redirectTo,
                state: {
                  from: location
                }
              }}
            />
          );
        }

        return React.Children.map(children, child =>
          React.isValidElement(child) ? React.cloneElement(child, props) : child
        );
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType,
  children: PropTypes.node,
  action: PropTypes.string,
  redirectTo: PropTypes.string
};

export default ProtectedRoute;
